import React, { useContext, useEffect, useState } from 'react';
import { displayContext } from '@/components/pages/assessments/context/display.context';
import Button from '@/components/Button/Button';

const QuestionCount = ({ question, answer, setAnswer, setQuestionComplete, previewOnly = false }) => {
  const { css } = useContext(displayContext);
  const [value, setValue] = useState(answer);

  const autoAdvance = false; // TODO option to either go straight to the next question or click Continue first
  const required = !!question.required;

  // show buttons for numbers zero through the max_value
  const maxValue = parseInt(question.max_value);
  if (!maxValue || maxValue < 1) {
    throw new Error('Invalid max_value for count type');
  }
  const numberList = [];
  for (let i = 0; i <= maxValue; i++) {
    numberList.push(i);
  }

  useEffect(() => {
    if (!previewOnly) {
      setQuestionComplete(!required || (value !== null && value !== undefined));
      setAnswer(value);
    }
  }, [value, previewOnly]);

  const handleClick = (opt) => {
    if (!previewOnly) {
      setValue(opt);
    }
  };

  const createBtn = (opt) => {
    const sel = value === opt ? 'selected' : 'unselected';
    return (
      <div className={css('question-option')} key={`${question.id}-${opt}`}>
        <Button
          additionalClasses={`${css('option-selectable-btn')} text-center`}
          shape="rounded"
          state={sel}
          border={true}
          text={opt.toString()}
          onButtonClick={() => handleClick(opt)}
          disabled={previewOnly}
        ></Button>
      </div>
    );
  };

  return (
    <>
      <div className={`${css('question-count-answer-label')}`}>{question.helper_text || ''}</div>
      <div className={`question-input question-count ${css('question-count')}`}>{numberList.map((opt) => createBtn(opt))}</div>
    </>
  );
};

export default QuestionCount;
